module.exports = __webpack_public_path__ + "img/logo.c388aab9.png";